import { useState } from '#imports'
import { watch } from 'vue'

export const useGameProgression = () => {
    // Stores array of completed template IDs
    const completedTemplates = useState<string[]>('completedTemplates', () => [])

    const markTemplateCompleted = (templateId: string) => {
        if (!templateId) return
        
        // Add if not already present
        if (!completedTemplates.value.includes(templateId)) {
            completedTemplates.value = [...completedTemplates.value, templateId]
            
            if (import.meta.client) {
                try {
                    localStorage.setItem('completed_templates', JSON.stringify(completedTemplates.value))
                } catch (e) {
                    console.error('[useGameProgression] Failed to save progression to localStorage', e)
                }
            }
        }
    }

    const hasCompletedTemplate = (templateId: string) => {
        return completedTemplates.value.includes(templateId)
    }

    const hasCompletedAllTemplates = (templateIds: string[]) => {
        return templateIds.every((id) => hasCompletedTemplate(id))
    }

    const initProgression = () => {
        if (import.meta.client) {
            try {
                const stored = localStorage.getItem('completed_templates')
                if (stored) {
                    const parsed = JSON.parse(stored)
                    if (Array.isArray(parsed)) {
                        completedTemplates.value = parsed
                    }
                }
            } catch (e) {
                console.error('[useGameProgression] Failed to load progression from localStorage', e)
            }
        }
    }

    // Return refs and methods
    return {
        completedTemplates,
        markTemplateCompleted,
        hasCompletedTemplate,
        hasCompletedAllTemplates,
        initProgression
    }
}
